import { render } from "./CvdGasProperties.vue?vue&type=template&id=e4872318"
import script from "./CvdGasProperties.vue?vue&type=script&lang=js"
export * from "./CvdGasProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__